export default __webpack_public_path__ + "static/4-3bdfdd7fd1330a63670a27dcfa64002c.png";